module.exports = __webpack_public_path__ + "fonts/Roboto-Italic.89909ce6.woff2";